module.exports = __webpack_public_path__ + "img/spiral-anticlockwise-middle.c89f42df.png";